<template>
  <b-avatar
    v-if="user && (user.avatar || user.avatarThumbnail)"
    :size="size"
    :src="user.avatarThumbnail"
  />
  <b-avatar v-else :size="size" :text="customerInitials" class="bg--primary" />
</template>

<script>
import { getInitials } from "@/utils/utils";
export default {
  name: "Avatar",
  props: ["size", "user"],
  computed: {
    customerInitials() {
      if (this.user) {
        if (this.user.fullname) {
          return getInitials(this.user.fullname);
        } else {
          let fullName = `${this.user.firstName} ${this.user.lastName}`;
          return fullName.match(/\b(\w)/g).join("");
        }
      } else {
        return "";
      }
    }
  },
  methods: {}
};
</script>

<style></style>
